// Module
var code = "<span class=\"sw-font-awesome\" ng-bind-html=\"$ctrl.svg\" ng-style=\"$ctrl.style\" ng-class=\"$ctrl.class\"></span> ";
// Exports
export default code;